import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import requestToken from "../firebase/requestToken";
import { errorMsg } from "../utils/toastMessage";
import { handleApiRequest } from "../services/handleApiRequest";
import { manageFirebaseToken } from "../redux/common/thunk";

export default function useNotificationPermissions() {
  const { loggedinUser } = useSelector((state) => state.auth);
  const [notificationPermission, setNotificationPermission] = useState();

  const handleFirebaseToken = async (token) => {
    const request = { firebaseToken: token };
    const response = await handleApiRequest(manageFirebaseToken, request);
    if (!response.status && !window.ReactNativeWebView) {
      errorMsg("Failed to enable notification");
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined" && "permissions" in navigator) {
      navigator.permissions.query({ name: "notifications" }).then(function (permission) {
        setNotificationPermission(permission.state);
        permission.onchange = function () {
          setNotificationPermission(permission.state);
        };
      });
    }
  }, []);

  useEffect(() => {
    (async () => {
      try {
        if (loggedinUser?.token) {
          if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(
              JSON.stringify({
                event: "loggedIn",
                user: loggedinUser, // or token
              })
            );
          }

          if (notificationPermission === "prompt") {
            await Notification.requestPermission();
          }
          if (
            notificationPermission &&
            notificationPermission === "granted" &&
            !loggedinUser.firebaseToken
          ) {
            const firebaseToken = await requestToken();
            if (firebaseToken) {
              handleFirebaseToken(firebaseToken);
            }
          } else if (notificationPermission === "denied" && !window.ReactNativeWebView) {
            errorMsg("Notification permission denied");
          }
        }
      } catch (error) {
        console.log("error", error);
      }
    })();
  }, [notificationPermission, loggedinUser]);

  return {};
}
